import React from "react"
import { Flex, Box, Button, VStack, Text } from "@chakra-ui/react"
import { Icon } from "../../components/common"
import { Link } from "gatsby"

export default function Pagionation({ previous, next }) {
  const disabledProps = {
    _active: { bg: null },
    _hover: { bg: null },
    isDisabled: true,
    as: "a",
  }

  return (
    <Flex as="nav" justify="space-between">
      <VStack mb="auto">
        <Button
          {...(previous
            ? { as: Link, to: previous.fields.slug }
            : { ...disabledProps })}
          variant="primary"
          rel="prev"
          size="sm"
          mr="auto"
        >
          <Box as={Icon} name="arrowLeft" boxSize={4} />

          <Text
            display={{ base: "none", xs: "flex" }}
            ml={{ base: 0, xs: 2 }}
            lineHeight={1}
            as="span"
            size="sm"
          >
            Prev
          </Text>
        </Button>
        <Text
          isTruncated
          textAlign="left"
          size="xs"
          w={{ base: "150px", xs: "auto" }}
        >
          {previous && previous.frontmatter.title}
        </Text>
      </VStack>

      <VStack alignSelf="flex-end" mb="auto">
        <Button
          {...(next
            ? { as: Link, to: next.fields.slug }
            : { ...disabledProps })}
          variant="primary"
          rel="next"
          size="sm"
          ml="auto"
        >
          <Text
            display={{ base: "none", xs: "flex" }}
            mr={{ base: 0, xs: 2 }}
            lineHeight={1}
            as="span"
            size="sm"
          >
            Next
          </Text>
          <Box as={Icon} name="arrowRight" boxSize={4} />
        </Button>
        <Text
          isTruncated
          textAlign="right"
          size="xs"
          w={{ base: "150px", xs: "auto" }}
        >
          {next && next.frontmatter.title}
        </Text>
      </VStack>
    </Flex>
  )
}
